<template>
  <div class="rain-notification">
    <el-dialog title="雨情通报" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body=false ref="rqtbRef"
      :before-close="() => params.flag && $parent.toggleProductView(params.productInfo.code)">
      <div slot="title" class="select-header">
        <div class="name">
          <span>雨情通报</span>
        </div>
        <div class="tu-time">
          <el-button type="primary" size="mini" @click="exportExcel" v-loading="loading">下载</el-button>
        </div>
      </div>
      <div class="table-data" ref="tabelRef">
        <el-table :data="tableData" height="100%" style="width: 100%" :span-method="objectSpanMethod"
          :cell-class-name="tableRowClassName">
          <el-table-column prop="county" label="区域" width="100px">
          </el-table-column>
          <el-table-column prop="cont" label="雨晴内容"></el-table-column>
          <el-table-column label="操作" width="50px">
            <template>
              <!-- <button class="print"></button> -->
              <img style="width: 1.15vw;" src="../assets/images/链接.png" alt="" title="链接">
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="charts">
        <div class="chart-item">
          <div class="title">累计雨量</div>
          <div class="chart-wrap">
            <div id="total-rain-chart1"></div>
          </div>
        </div>
        <div class="chart-item">
          <div class="title">雨量地图</div>
          <div class="image-box">
            <img :src="`${base_url}/rainPic/R${tabIndex}H.jpg`" alt="">
            <img :src="`${base_url}/rainPic/w-cover.jpg`" alt="">
          </div>
          <div class="h-time">
            <span :class="{ active: tabIndex === '01' }" @click="tabIndex = '01'">1小时</span>
            <span :class="{ active: tabIndex === '03' }" @click="tabIndex = '03'">3小时</span>
            <span :class="{ active: tabIndex === '06' }" @click="tabIndex = '06'">6小时</span>
            <span :class="{ active: tabIndex === '12' }" @click="tabIndex = '12'">12小时</span>
            <span :class="{ active: tabIndex === '24' }" @click="tabIndex = '24'">24小时</span>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import echarts from '@/config/echarts/index.js'
import { getYQReportOption } from '@/config/echarts/option/yuqing-report'
import { apiData } from '../api/index'

export default {
  props: ['params'],
  data() {
    return {
      loading: false,
      tabIndex: '01',
      tableData: [],
      rootFontSize: this.$rootFontSize,
      base_url: process.env.VUE_APP_DATA
    }
  },
  watch: {
    'params.flag': {
      handler(flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  created() {
    this.queryYuQiData()
  },

  mounted() {
    this.$nextTick(() => {
      this.initEchart()
    })
  },
  methods: {

    // 初始换请求的时间
    initTime() {
      const currentTime = new Date().getTime()
      const day = new Date().getDate() - 1
      const startTime = this.$moment(currentTime - 86400000 * day).format('YYYY-MM-DD HH:mm:ss')
      const endTime = this.$moment(currentTime).format('YYYY-MM-DD HH:mm:ss')
      this.datetime = [startTime, endTime]
    },

    async queryYuQiData() {
      // 拼接请求参数
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const unitid = unit.id
      const result = await apiData.getYuqiData(unitid)
      this.tableData = []
      result.data.forEach(item => {
        item.conts.forEach((cont, index) => {
          this.tableData.push({ county: item.county, cont: cont, col: index === 0 ? item.conts.length : 0 })
        })
      })
      // this.tableData = [...this.tableData, ...this.tableData, ...this.tableData]
    },

    initEchart() {
      const monthChart = echarts.init(document.getElementById('total-rain-chart1'))
      const option = getYQReportOption({ x: [''] })
      monthChart.setOption(option)
      window.addEventListener('resize', () => {
        monthChart.resize()
      })
    },
    exportExcel(excelName) {
      this.loading = true
      try {
        const $e = this.$refs.tabelRef
        const $table = $e
        const wb = XLSX.utils.table_to_book($table, { raw: true })
        const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        console.log($table, wb, wbout)
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          '雨晴通报.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.error(e)
      }
      this.loading = false
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.col,
          colspan: 1
        }
      }
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'cell-bg'
      } else {
        return ''
      }
    },
    // 设置弹出框的zIndex
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.rqtbRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.rain-notification {
  pointer-events: none;

  .select-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 2.6vw;
    font-size: 0.94vw;
    font-weight: 600;
    color: #81C3FF;
    line-height: 1.3vw;

    .name {
      display: flex;
      align-items: center;
    }

  }

  .table-data {
    margin: 1.19rem 0;
    margin-right: 3.07vw;
    width: 37.03vw;

    .el-table {
      background: #25324D;
      text-align: center;

      /deep/ tr {
        th {
          text-align: center;
          border: 0;
          font-size: 0.88rem;
          font-weight: 600;
          color: #FFF;
          background: #1F2C49;
        }

        td {
          text-align: center;
          font-size: 0.88rem;
          font-weight: 400;
          color: #FFF;
          background: #25324D;
          border-bottom: 1px solid #3E4C6A;
        }

        .image {
          margin: 0.52vw;
          width: 1.09vw;
          cursor: pointer;
        }
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #42506E;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #42506E;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #1F2C49;
      }

      /deep/.el-table__fixed-right-patch {
        background: #f8faff;
        border: 0;
      }
    }

    .el-table::before,
    /deep/.el-table__fixed-right::before {
      background: transparent;
    }
  }

  .charts {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;

    .chart-item {
      display: flex;
      flex-direction: column;
      flex: 1;
      position: relative;
      overflow: hidden;

      .title {
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #FFF;
      }

      .chart-wrap {
        flex: 1;
        position: relative;

        #total-rain-chart1 {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }

      }

      .image-box {
        width: 100%;
        height: 100%;
        overflow: hidden;

        img {
          height: 100%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          height: 100%;
        }

        img:nth-child(2) {
          // height: calc(100% + 2px);
          // transform: translate(-50% + 1px);
        }
      }

      .h-time {
        position: absolute;
        right: 20px;
        height: 100%;
        display: flex;
        flex-direction: column;

        span {
          text-align: center;
          padding: 0.26vw 0vw;
          margin: 0.52vw 0vw;
          width: 3.96vw;
          font-size: 0.83vw;
          color: #FFF;
          background: #1F2C49;
          box-shadow: 0vw 0.1vw 0.42vw 0vw rgba(229, 207, 207, 0.07);
          border-radius: 0.31vw;
          border: 0.05vw solid #d8dde6;

          &:hover {
            cursor: pointer;
          }
        }

        span.active {
          box-shadow: 0vw 0.1vw 0.42vw 0vw rgba(0, 0, 0, 0.07);
          color: #2D74F5;
          border: 0.05vw solid #2D74F5;
        }

      }
    }
  }

  /deep/.el-dialog__wrapper {
    overflow: hidden;

    .el-dialog {
      pointer-events: auto;
      width: 85.81rem;
      margin-top: 8vh !important;
      height: 84vh;
    }
  }
}

/deep/.el-dialog__body {
  display: flex;
  flex-direction: row !important;
  overflow: hidden;
}

/deep/ .el-table .cell-bg {
  background: #FAFCFF !important;
}
</style>
